<template>
  <v-page>
    <v-link to="/me/my-content">
      <toolbar class="mb-3" :logo="false">
        <template v-slot:left>
          <span class="v-toolbar__text">
            {{ toolbarText }}
          </span>
        </template>
      </toolbar>
    </v-link>

    <div v-if="isLoading" class="d-flex justify-content-center py-4">
      <v-loader />
    </div>
    <template v-else>
      <list class="submissions-number__list" boxed>
        <list-item
          v-for="(form, index) in forms"
          :key="index"
          chevron
          @click="() => handleClick(form)"
        >
          {{ form.title }}

          <template slot="right">
            <span class="v-list-item__subtitle">
              <strong>{{ form.submissions_count }}</strong></span
            >
          </template>
        </list-item>
      </list>
    </template>
  </v-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import List from "@/components/List"
import ListItem from "@/components/ListItem"
import Toolbar from "@/components/Toolbar"

const WORKOUT_TYPE = "workout_capture_form"

export default {
  components: {
    List,
    ListItem,
    Toolbar
  },

  data() {
    return {
      forms: [],
      isLoading: false
    }
  },

  mounted() {
    this.loadForms()
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),

    formType() {
      return this.$route.params.formType
    },

    toolbarText() {
      if (this.formType === WORKOUT_TYPE) {
        return "Workouts"
      } else {
        return "My Submissions"
      }
    }
  },

  methods: {
    ...mapActions("forms", ["fetchFormsSubmissionsNumber"]),

    loadForms() {
      if (this.isAuthenticated) {
        this.isLoading = true

        this.fetchFormsSubmissionsNumber(this.formType)
          .then(res => {
            this.forms = res.data.forms
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },

    handleClick({ id, form_type }) {
      if (form_type) {
        this.$router.push(`/me/submissions/${form_type}`)
      } else {
        this.$router.push(`/me/forms/${id}/submissions`)
      }
    }
  },

  watch: {
    isAuthenticated() {
      this.loadForms()
    }
  }
}
</script>
